import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ChatflowCommentRequest,
  ChatflowCommentResponse,
  ChatflowVersionResponse,
  ChatflowVersionRestoreResponse
} from '../models/chatflow-history.model';

/**
 * Historial de publicaciones y notas del equipo de un chatflow. Ambos endpoints devuelven
 * arrays planos (no paginados): el historial de un chatflow es corto por naturaleza.
 */
@Injectable({ providedIn: 'root' })
export class ChatflowHistoryApiService {
  private readonly base = `${environment.apiUrl}api/chatflows`;

  constructor(private http: HttpClient) {}

  getVersions(chatflowId: number): Observable<ChatflowVersionResponse[]> {
    return this.http.get<ChatflowVersionResponse[]>(`${this.base}/${chatflowId}/versions`);
  }

  /** Calcula el impacto de restaurar SIN aplicar nada, para confirmarlo con datos. */
  previewRestore(chatflowId: number, versionId: number): Observable<ChatflowVersionRestoreResponse> {
    return this.http.get<ChatflowVersionRestoreResponse>(
      `${this.base}/${chatflowId}/versions/${versionId}/restore-preview`
    );
  }

  restoreVersion(chatflowId: number, versionId: number): Observable<ChatflowVersionRestoreResponse> {
    return this.http.post<ChatflowVersionRestoreResponse>(
      `${this.base}/${chatflowId}/versions/${versionId}/restore`, {}
    );
  }

  getComments(chatflowId: number): Observable<ChatflowCommentResponse[]> {
    return this.http.get<ChatflowCommentResponse[]>(`${this.base}/${chatflowId}/comments`);
  }

  createComment(chatflowId: number, request: ChatflowCommentRequest): Observable<ChatflowCommentResponse> {
    return this.http.post<ChatflowCommentResponse>(`${this.base}/${chatflowId}/comments`, request);
  }

  updateComment(chatflowId: number, commentId: number, request: ChatflowCommentRequest): Observable<ChatflowCommentResponse> {
    return this.http.put<ChatflowCommentResponse>(`${this.base}/${chatflowId}/comments/${commentId}`, request);
  }

  deleteComment(chatflowId: number, commentId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${chatflowId}/comments/${commentId}`);
  }
}
